import SquigglyLine10Icon from '@/assets/icons/squiggly-lines/squiggly-line-10.svg?react';
import SquigglyLine3Icon from '@/assets/icons/squiggly-lines/squiggly-line-3.svg?react';
import eternaLifeGraphImg from '@/assets/images/home/eterna-life-graph.png';
import { Button } from '@/components/common/Button';
import { Heading } from '@/components/common/Heading';
import { Section } from '@/components/common/Section';
import { useBreakpoint } from '@/lib/contexts/BreakpointContext';
import { routes } from '@/routes/routes';
import { ArrowRight as ArrowRightIcon } from '@carbon/icons-react';
import { Link } from '@tanstack/react-router';

export function TrustSection() {
  const { isDesktop } = useBreakpoint();

  return (
    <Section
      containerClassName="bg-secondary text-secondary-foreground"
      className="flex flex-col lg:block"
    >
      <Heading
        as="h2"
        className="mx-auto mb-8.75 max-w-88 leading-10 sm:max-w-none lg:mb-29"
        underlinedText="trust us,"
        underline={
          isDesktop ? (
            <SquigglyLine10Icon className="-bottom-5 -left-1" />
          ) : (
            <SquigglyLine3Icon className="-bottom-1.5" />
          )
        }
      >
        Doctors trust us, patients love us
      </Heading>

      <div className="flex flex-col lg:flex-row lg:items-center">
        <div className="lg:w-full">
          <Heading asChild size="label" className="mb-3 text-left lg:mb-5">
            <p>Customers recommend</p>
          </Heading>

          <Heading as="h3" size="h2" className="mb-5 text-left lg:max-w-111">
            People rate our service higher than the average pharmacy
          </Heading>

          <p className="mb-11 text-left text-[#CCCCCC] lg:mb-12 lg:max-w-111 lg:text-lg">
            No more pharmacy runs. We deliver what you need, when you need it.
          </p>

          {isDesktop && (
            <Button variant="outlineAccent" animate asChild>
              <Link to={routes.auth.login}>
                <ArrowRightIcon />
                <p>Find your doctor</p>
              </Link>
            </Button>
          )}
        </div>

        <img
          src={eternaLifeGraphImg}
          alt="Eterna Life Graph"
          className="mb-13 lg:mb-0 lg:w-full lg:min-w-0"
        />

        {!isDesktop && (
          <Button
            variant="outlineAccent"
            animate
            className="self-center"
            asChild
          >
            <Link to={routes.auth.login}>
              <ArrowRightIcon />
              <p>Find your doctor</p>
            </Link>
          </Button>
        )}
      </div>
    </Section>
  );
}
